/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

import { getCombinedClassNames } from 'utils/style';

const CtaBlockElem = styled.div.attrs(({ fullWidth }) => {
  const baseClassNames = ['bg-secondary-300', 'rounded-base', 'text-center', 'px-4', 'py-8'];
  const halfWidthClassNames = ['lg:py-8', 'lg:px-12', 'lg:w-4/6', 'lg:mx-auto'];
  const fullWidthClassNames = ['lg:px-40', 'lg:py-20'];
  let classNameToAdd = [...baseClassNames];
  if (fullWidth) {
    classNameToAdd = [...baseClassNames, ...fullWidthClassNames];
  } else {
    classNameToAdd = [...baseClassNames, ...halfWidthClassNames];
  }

  return {
    className: getCombinedClassNames(classNameToAdd),
  };
})``;

export { CtaBlockElem };
